module.exports = __webpack_public_path__ + "img/ewm2.e8563bdd.png";